module.exports = __webpack_public_path__ + "static/media/instagram.0b639099.svg";